export default {
  GET_DISCLOSURE_UPLOADED_FILES: {
    url: '/upload-file/list',
    method: 'GET'
  },
  UPLOAD_CSV_FILE: {
    url: '/upload-file/upload-csv',
    method: 'POST'
  },
  UPLOAD_PDF_FILE: {
    url: '/upload-file/upload-pdf',
    method: 'POST'
  },
  IMPORT_CSV_FILE: {
    url: '/upload-file/import-csv-file',
    method: 'POST'
  },
  CHECK_IMPORT_PROGRESS: {
    url: '/upload-file/check-import-progress',
    method: 'GET'
  },
  DOWNLOAD_TEMPLATE: {
    url: '/upload-file/download-template',
    method: 'GET'
  },
  DOWNLOAD_ERROR_LOG: {
    url: '/upload-file/download-file-error',
    method: 'GET'
  },
  DELETE_UPLOADED_FILE: {
    url: '/upload-file/delete/',
    method: 'DELETE'
  },
  GET_YEARS_LIST: {
    url: '/upload-file/public/get-year',
    method: 'GET'
  },
  UPDATE_PUBLISH_PDF: {
    url: '/upload-file/update-publish-pdf',
    method: 'PUT'
  },
  GET_PDF: {
    url: '/upload-file/get-pdf',
    method: 'GET'
  }
};
